module.exports = __webpack_public_path__ + "img/72.cfbb7967.png";